var ReadOnlyExperiments = /** @class */ (function () {
    function ReadOnlyExperiments(options) {
        var _a;
        this.experiments = (_a = options.experiments) !== null && _a !== void 0 ? _a : {};
    }
    ReadOnlyExperiments.prototype.get = function (key) {
        return this.experiments[key];
    };
    ReadOnlyExperiments.prototype.enabled = function (key) {
        return this.get(key) === 'true';
    };
    ReadOnlyExperiments.prototype.pending = function () {
        return false;
    };
    ReadOnlyExperiments.prototype.ready = function () {
        return Promise.resolve();
    };
    ReadOnlyExperiments.prototype.all = function () {
        return this.experiments;
    };
    return ReadOnlyExperiments;
}());
export { ReadOnlyExperiments };
//# sourceMappingURL=ReadOnlyExperiments.js.map